import React, { useState } from 'react'
import useMerchantPortalAxios from "../utils/axios";
import { useDispatch } from 'react-redux';
import { setExternalCashDeposit, setGenerateCashDepositCode } from '../features/ExternalCashDepositSlice';

function useExternalCashApi () {
    const [isLoading, setIsLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [totalNbPage, setTotalNbPage] = useState(0);
    const MerchantPortalClient = useMerchantPortalAxios();
    const dispatch = useDispatch();


    const GetExternalCashDeposit = async (page) => {
        setIsLoading(true);
    
         try {
            await MerchantPortalClient.post('/v1/ExternalCashDeposit/GetExternalCashDeposit', {
                SessionID: sessionStorage.getItem("SessionID"),
                page: page,
                pageSize: 10
            })
            .then((res) => {
                const externalCashDeposits = res.data?.Payload?.ExternalCashDeposits || [];
                dispatch(setExternalCashDeposit(externalCashDeposits));
    
                if (externalCashDeposits.length === 0) {
                    setTotalNbPage(0);
                    setTotalCount(0);
                } else {
                    setTotalNbPage(externalCashDeposits[0]?.TotalPages || 0);
                    setTotalCount(externalCashDeposits[0]?.TotalCount || 0);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
        } catch (error) {
            console.error("Unexpected error:", error);
        }
    };
    

    const GenerateCashDepositCode = async (payload) => {
        const response = await MerchantPortalClient.post('/v1/ExternalCashDeposit/GenerateCashDepositCode', payload)
        dispatch(setGenerateCashDepositCode(response.data.Payload));
        return response.data.Payload;
    }
    
    

    return {
        GetExternalCashDeposit,
        isLoading,
        totalNbPage,
        totalCount,
        GenerateCashDepositCode
    }
}

export default useExternalCashApi;